import * as ObjectTypeIds from 'customer-data-filters-ui/constants/objectTypeIds';
import { LegacyFilterFamilyObjectNameTranslator } from 'customer-data-filters-ui/components/common/FilterFamilyTranslator';
import { getDefaultTranslationKey, getTranslationOptions } from 'customer-data-filters-ui/utils/filterFamilyTranslation';
const ObjectHasCustomLabels = [ObjectTypeIds.ENGAGEMENT_TYPE_ID, ObjectTypeIds.LINE_ITEM_TYPE_ID, ObjectTypeIds.SUBSCRIPTION_TYPE_ID];
export const objectHasCustomLabels = filterFamily => ObjectHasCustomLabels.includes(filterFamily);
export const getEditorFilterFamilyNameTranslation = (filterFamily, {
  getFilterFamilyEntityName = LegacyFilterFamilyObjectNameTranslator,
  getFilterFamilyTranslationKey = getDefaultTranslationKey
} = {}) => {
  const filterFamilyKey = getFilterFamilyTranslationKey(filterFamily);
  const options = getTranslationOptions({
    filterFamily,
    getFilterFamilyEntityName
  });
  return {
    key: `newCustomerDataFilters.FilterFamilyName.${filterFamilyKey}`,
    options
  };
};
export const getFilterFamilyGroupHeadingTranslation = (filterFamily, {
  getFilterFamilyEntityName = LegacyFilterFamilyObjectNameTranslator,
  getFilterFamilyTranslationKey = getDefaultTranslationKey,
  isEditor = true
} = {}) => {
  const filterFamilyKey = getFilterFamilyTranslationKey(filterFamily);
  const editorModeKey = isEditor ? 'editor' : 'viewer';
  const options = getTranslationOptions({
    filterFamily,
    getFilterFamilyEntityName
  });
  return {
    key: `newCustomerDataFilters.FilterFamilyGroupHeading.${editorModeKey}.${filterFamilyKey}`,
    options
  };
};